// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"a7b09349","787":"2daf5c88"}[chunkId] + ".chunk.js";
};